import React, { useState } from "react"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { logout } from "../../data/authenticationSlice"
import { useDispatch } from "react-redux"

const componentStyle = {
    background: "#fff !important",
    height: "80px !important",
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.4)",
    zIndex: "5",
    paddingTop: "12px"
}

function AgencyNavBar() {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [expanded, setExpanded] = useState(false)

    const handleToggle = () => setExpanded(!expanded)

    const _logout = (e) => {
        e.preventDefault()
        const refreshToken = window.sessionStorage.getItem("REFRESH_TOKEN")

        dispatch(logout({ refreshToken })).then(() => {
            let loc = location.pathname.split("/")[1]

            if (loc) {
                let route = loc === "admin" ? "/admin/login" : "/agency/login"
                navigate(route)
            }
        })
    }

    const handleNavLinkClick = () => {
        if (expanded) setExpanded(false)
    }

    return (
        <Navbar
            style={componentStyle}
            expand="lg"
            className="bg-body-tertiary"
            expanded={expanded}>
            <Container fluid>
                <NavLink
                    to="/agency/dashboard"
                    className="me-5">
                    <img
                        src="/GAIC.png"
                        alt="Mountain"
                        className="logo"
                    />
                </NavLink>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={handleToggle}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink
                            className="nav-link"
                            to="/agency/dashboard"
                            onClick={handleNavLinkClick}>
                            Dashboard
                        </NavLink>
                        <NavLink
                            className="nav-link"
                            to="/agency/create-application"
                            onClick={handleNavLinkClick}>
                            Create Application
                        </NavLink>

                        <NavLink
                            className="nav-link"
                            to="/agency/profile"
                            onClick={handleNavLinkClick}>
                            Profile
                        </NavLink>

                        <NavLink
                            className="nav-link"
                            onClick={(e) => {
                                handleNavLinkClick()
                                _logout(e)
                            }}>
                            Logout
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default AgencyNavBar
